'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

var _KeyboardArrowLeft = require('../SvgIcon/KeyboardArrowLeft');

var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);

var _Text = require('../Text');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('FullScreen', function (theme) {
  var fullScreen = {
    width: '100% !important',
    top: '0px !important',
    bottom: '0px  !important',
    position: 'fixed !important',
    zIndex: theme.zIndex.dialog + ' !important',
    overflow: 'auto !important',
    display: 'flex !important',
    flexFlow: 'column !important',
    left: '0px !important', // unset InfiniteList inline style
    height: 'unset !important' // unset InfiniteList inline style
  };

  var childContainer = {
    width: '100%',
    overflow: 'auto'
  };

  var showBack = {
    display: 'inline-flex',
    cursor: 'pointer',
    alignItems: 'center',
    marginTop: theme.typography.rhythmByUnit(2),
    marginRight: theme.typography.rhythmByUnit(1),
    marginLeft: theme.typography.rhythmByUnit(1)
  };

  return theme.breakpoints.keys.reduce(function (styles, breakpoint) {
    var _theme$breakpoints$do;

    return Object.assign({}, styles, _defineProperty({}, theme.breakpoints.down(breakpoint), (_theme$breakpoints$do = {}, _defineProperty(_theme$breakpoints$do, 'root-' + breakpoint, fullScreen), _defineProperty(_theme$breakpoints$do, 'child-' + breakpoint, childContainer), _defineProperty(_theme$breakpoints$do, 'back-' + breakpoint, showBack), _theme$breakpoints$do)));
  }, {
    back: {
      display: 'none'
    },
    icon: {
      height: theme.spacing.unit * 3,
      width: theme.spacing.unit * 3
    }
  });
});

var FullScreen = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(FullScreen, _React$PureComponent);

  function FullScreen() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FullScreen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FullScreen.__proto__ || Object.getPrototypeOf(FullScreen)).call.apply(_ref, [this].concat(args))), _this), _this.component = undefined, _this.focus = function () {
      if (_this.component && typeof _this.component.focus === 'function') {
        _this.component.focus();
      }
    }, _this.handleBackClick = function (e) {
      var onBackClick = _this.props.onBackClick;

      if (onBackClick) onBackClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FullScreen, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            backTextProp = _props.backText,
            BackIcon = _props.backIcon,
            breakpoint = _props.breakpoint,
            Component = _props.component,
            classNameProp = _props.className,
            expand = _props.expand,
            children = _props.children,
            onBackClick = _props.onBackClick,
            other = _objectWithoutProperties(_props, ['backText', 'backIcon', 'breakpoint', 'component', 'className', 'expand', 'children', 'onBackClick']);

        var classes = this.context.styleManager.render(styleSheet);
        var rootClassName = (0, _classnames2['default'])(_defineProperty({}, classes['root-' + breakpoint], expand), classNameProp);
        var childClassName = (0, _classnames2['default'])(_defineProperty({}, classes['child-' + breakpoint], expand));
        var backClassName = (0, _classnames2['default'])(classes.back, _defineProperty({}, classes['back-' + breakpoint], expand));
        var backText = typeof backTextProp === 'string' ? _react2['default'].createElement(
          _Text.Headline,
          { component: 'span' },
          backTextProp
        ) : backTextProp;
        /* eslint-disable */
        return _react2['default'].createElement(
          Component,
          _extends({
            className: rootClassName,
            ref: function () {
              function ref(node) {
                return _this2.component = node;
              }

              return ref;
            }()
          }, other),
          _react2['default'].createElement(
            'div',
            { className: childClassName },
            Boolean(expand && backTextProp) && _react2['default'].createElement(
              'div',
              {
                className: backClassName,
                role: 'button',
                onClick: this.handleBackClick
              },
              _react2['default'].createElement(BackIcon, { className: classes.icon }),
              backText
            ),
            children
          )
        );
        /* eslint-enable */
      }

      return render;
    }()
  }]);

  return FullScreen;
}(_react2['default'].PureComponent), _class.defaultProps = {
  backText: 'Back',
  backIcon: _KeyboardArrowLeft2['default'],
  breakpoint: 'sm',
  component: 'div',
  expand: false
}, _temp2);
exports['default'] = FullScreen;


FullScreen.displayName = 'FullScreen';

FullScreen.contextTypes = {
  styleManager: _propTypes2['default'].object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/internal/FullScreen.js
// module id = 1746
// module chunks = 32